export const fontFamilies = {
  body: {
    normal: 'cera-pro-normal-regular, sans-serif'
  },
  primary: {
    normal: 'cera-pro-normal-medium, sans-serif',
    bold: 'cera-pro-normal-bold, sans-serif'
  }
};
